import { theme } from 'antd';

export const useToken = () => {
  const token = theme.useToken();

  return {
    ...token,
    token: {
      ...token.token,
      // primaries
      'classic-blue': '#0054AE',
      white: '#FFFFFF',
      'carbon-shade-2': '#262626',

      // accents
      'energy-blue': '#00C7FD',
      'blue-steel': '#548FAD',
      cobalt: '#1E2EB8',
      geode: '#8F5DA2',
      moss: '#8BAE46',
      daisy: '#FEC91B',
      rust: '#E96115',
      coral: '#FF5662',

      // natural status colors
      'natural-error': '#F5C7C7',
      'natural-warning': '#FFF6CC',
      'natural-success': '#C2E5C2',

      // soft status colors
      'soft-error': '#F88F8F',
      'soft-warning': '#FFEB92',
      'soft-success': '#ADD2AD',

      // bright status colors
      'bright-error': '#CE0000',
      'bright-warning': '#FFD100',
      'bright-success': '#008A00',
    },
  };
};
